import { MapContainer, Popup, Marker, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Box, Button, List, ListItem, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import Leaflet from "leaflet";
import markerIcon from "../../../assets/location-marker.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { MainContext } from "../../../main/context/MainContextProvider";
var greenIcon = Leaflet.icon({
  iconUrl: markerIcon,
  iconSize: [38, 38], // size of the icon
});
export type UsinaLocationMapProps = {
  latitude: number;
  longitude: number;
  onClickEditLocation?: () => void;
  width?: string;
  height?: string;
};

export default function UsinaLocationMap(props: UsinaLocationMapProps) {
  const mapRef = useRef(null);

  const plantPositions: [number, number] = [props.latitude, props.longitude];
  const { theme } = useContext(MainContext);
  const [mapTileUrl, setMapTileUrl] = useState("");

  useEffect(() => {
    setMapTileUrl(
      theme.name == "dark"
        ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        : "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
    );
  }, [theme]);
  return (
    <div
      style={{
        height: props.height ?? "100%",
        width: props.width ?? "100%",
      }}
      className="d-flex justify-content-center align-items-center"
    >
      <MapContainer
        style={{
          height: "100%",
          width: "100%",
        }}
        center={plantPositions}
        ref={mapRef}
        maxZoom={18}
        scrollWheelZoom={true}
        zoom={5}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url={mapTileUrl}
        />
        <Marker
          eventHandlers={{
            click: (event) => {
              if (event.popup.isOpen()) {
                event.target.closePopup();
              } else {
                event.target.openPopup();
              }
            },
          }}
          position={plantPositions}
          icon={greenIcon}
        >
          <Popup closeButton={false}>
            <List
              sx={{
                fontSize: "10px",
                // height: "80px",
              }}
            >
              <ListItem>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ fontWeight: "700", fontSize: "16px" }}>
                    Localização da Usina
                  </Typography>
                  <Typography sx={{ fontSize: "14px" }}>
                    Latitude: {props.latitude}
                    <br />
                    Longitude: {props.longitude}
                  </Typography>

                  <Button
                    onClick={props.onClickEditLocation}
                    variant="contained"
                    color="primary"
                    style={{
                      fontSize: "10px",
                    }}
                  >
                    <FontAwesomeIcon
                      size="sm"
                      icon={faPen}
                      style={{
                        marginRight: "5px",
                      }}
                    />
                    Editar
                  </Button>
                </Box>
              </ListItem>
            </List>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}
